import * as apiBff from './bff'

export async function getSubdepartments<T>(season: string, universeId: number, departmentId: number): Promise<T> {
  return apiBff.callBFF<T>('GET', `season/${season}/universes/${universeId}/departments/${departmentId}`)
}
